import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root"
})
export class GstCalculationService {
  constructor(private http: HttpUtilService) {}

  getDetailsByContractNo(contractNo: string): Observable<any> {
    const params = new URLSearchParams({ contractNo }).toString();
    return this.http.get(`GstCalculationService.asmx/GetDetailsByContractNo?${params}`);
  }

  saveGst(payload: any): Observable<any> {
    return this.http.post("GstCalculationService.asmx/SaveGst", payload);
  }

  printGst(contractNo: string): Observable<any> {
    return this.http.post("GstCalculationService.asmx/Print", {
      model: { Name: "ContractNo", Value: contractNo }
    });
  }

  updateFields(data: any, fieldName: string): Observable<any> {
    return this.http.post(`GstCalculationService.asmx/UpdateFields`, {
      data,
      fieldName
    });
  }
}
